import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { error } from "app/themes/colors";
import React from "react";
import { formatBirthdateAsString } from "utils/common";

interface UserCardProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  birthdate: string | Date;
}

function WebPatientDetails({
  firstName,
  lastName,
  email,
  phone,
  birthdate,
}: UserCardProps) {
  return (
    <Box
      display="flex"
      flex="1"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box sx={{ mt: 0.5, mr: 1.5, height: 24, width: 24 }} flex="0 0 1" />
      <Box flex={1} bgcolor="grey.100" borderRadius={4} boxShadow={2} p={2}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography>
            Web appointment for {firstName} {lastName}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body1">Phone: {phone}</Typography>
          {email && (
            <Typography variant="body1" gutterBottom>
              Email: {email}
            </Typography>
          )}
          {birthdate && (
            <Typography variant="body1">
              Date of Birth:{" "}
              {formatBirthdateAsString(birthdate) || (
                <Box component="span" sx={{ color: error[700] }}>
                  Not on File
                </Box>
              )}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default WebPatientDetails;
